import { createFileRoute } from "@tanstack/react-router";
import { Image } from "@/components/image";
import {
  ScaffoldSection,
  ScaffoldSectionContainer,
  ScaffoldSectionContent,
  ScaffoldSectionDescription,
  ScaffoldSectionHeader,
  ScaffoldSectionTitle,
} from "@/components/www/sections/scaffold";
import { seo } from "@/lib/seo";

export const Route = createFileRoute("/_www/historie")({
  component: RouteComponent,
  head: () =>
    seo({
      title: "Historie – Alte Papierfabrik Wuppertal",
      description:
        "Die Geschichte der Alten Papierfabrik Wuppertal – von der historischen Fabrik zum modernen Freizeit- und Entertainmentcenter.",
      path: "/historie",
    }),
});

function RouteComponent() {
  return (
    <ScaffoldSection className="relative z-0 bg-accent text-[#2A4154] md:pt-24">
      <Image
        alt="Brick texture"
        className="-z-10 absolute top-0 left-0 w-1/4 max-w-40"
        height={220}
        src="/images/brick_texture.png"
        width={130}
      />
      <Image
        alt="Brick texture"
        className="-z-10 absolute right-0 bottom-0 w-1/4 max-w-40 rotate-180"
        height={220}
        src="/images/brick_texture.png"
        width={130}
      />
      <ScaffoldSectionContainer>
        <ScaffoldSectionHeader>
          <ScaffoldSectionDescription>
            Die Geschichte der Alten Papierfabrik
          </ScaffoldSectionDescription>
          <ScaffoldSectionTitle>Historie</ScaffoldSectionTitle>
        </ScaffoldSectionHeader>
        <ScaffoldSectionContent>
          <section className="prose max-w-full px-4">
            <p className="text-lg leading-relaxed">
              Eine Stadt lebt mit ihren aber besonders auch durch Ihre Menschen.
              Wenn diese Menschen dann innovative Ideen umsetzten, erwachen alte
              Gebäude aus ihrem Dornröschenschlaf. Und so ist dies auch mit und
              in der Alten Papierfabrik geschehen. Mit viel Liebe zum Detail
              wurde aus einem alten Gebäude ein über die Grenzen der Stadt
              hinaus bekannter Treffpunkt.
            </p>

            <div className="mt-8 space-y-6">
              <p className="leading-relaxed">
                <span className="font-bold text-2xl">1876</span> gründete Carl
                Remkes im Haus Nr. 130 eine kleine Papierfabrik, aus der 1899
                die Elberfelder Papierfabrik AG wurde. Man produzierte neben
                Papier für Briefkuverts vor allem Feinpapier, Elfenbein- und
                Bristolkartons. Die Fabrik wurde um die Jahrhundertwende groß
                ausgebaut und erweitert.
              </p>

              <p className="leading-relaxed">
                <span className="font-bold text-2xl">1899</span> wurde sie zu
                einer Aktiengesellschaft mit Sitz in Berlin-Zehlendorf
                umgewandelt. Das Unternehmen produzierte in Elberfeld bis Anfang
                der 1960er Jahre. Nach Einstellung der Papierfabrikation dienten
                die Hallen und Räume hauptsächlich als Lager für verschiedene
                Nutzer, aber auch für unterschiedliche Kleingewerbe.
              </p>

              <p className="leading-relaxed">
                <span className="font-bold text-2xl">1998</span> stand der
                Gebäudekomplex dann zum Verkauf. Die Betreiber des SPORT-PARKs
                in Wuppertal-Vohwinkel konnten somit ihre Expansionspläne in
                diesem Komplex verwirklichen.
              </p>

              <p className="leading-relaxed">
                <span className="font-bold text-2xl">2000</span> wurde dann der
                SPORT-PARK Elberfeld eröffnet. In den teilweisen 140 Jahre alten
                Gemäuern wurde ein großes Fitness- und Aerobicstudio,
                Bowlingbahnen, Gastronomie sowie ein großer Eventbereich
                eröffnet. Der erste Umbauabschnitt umfasste eine Größe von
                zunächst 7.800 qm Nutzfläche und wurde gemeinsam mit dem
                bekannten Wuppertaler-Architekten Alexander Rocho durchgeführt.
                Es wurde darauf geachtet, die reizvolle und historische
                Bausubstanz weitgehenst zu erhalten. Der Eventbereich der Alten
                Papierfabrik hat eine Zulassung von 1.100 Gästen.
              </p>

              <p className="leading-relaxed">
                <span className="font-bold text-2xl">2003</span> wurde dann der
                Rest der ehemaligen Alten Elberfelder Papierfabrik übernommen
                und weiter ausgebaut. Heute beherbergt er auf weiteren 4.800 qm
                Büro, Praxis und Wohnungsräume. Durch diesen weiteren
                Bauabschnitt konnte auch der SPORT-PARK Elberfeld vergrößert
                werden.
              </p>

              <p className="leading-relaxed">
                <span className="font-bold text-2xl">2006</span> wurde der Bau
                und seine Investoren für seine lebendige Unternehmenskultur im
                bergischen Städtedreieck Solingen-Remscheid-Wuppertal im Zuge
                der Regionale 2006 ausgezeichnet. Ebenfalls findet man diesen
                Komplex in der "Industrieroute 5" der Stadt Wuppertal als eines
                der interessantesten historischen Bauwerke wieder.
              </p>

              <p className="leading-relaxed">
                <span className="font-bold text-2xl">2010</span> In einer
                dritten Umbauphase wurden rund 1,5 Millionen Euro in das
                Restaurant PAPERS mit einer Cocktailbar und in die neue
                Sportsbar investiert.
              </p>

              <p className="leading-relaxed">
                <span className="font-bold text-2xl">2011</span> Eröffnung
                Restaurant der neuen „Alte Papierfabrik"
              </p>

              <p className="leading-relaxed">
                <span className="font-bold text-2xl">2013</span> Enchilada –
                Restaurante y bar mexicano
              </p>

              <p className="leading-relaxed">
                <span className="font-bold text-2xl">2015</span> Nach
                6-monatiger Bauzeit wurde im Februar die erste 3D Schwarzlicht
                Minigolf-Anlage im Bergischen Land in den Untergeschossen der
                Alten Papierfabrik eröffnet.
              </p>
            </div>

            <div className="pt-8">
              <p className="text-lg leading-relaxed">
                Heute steht den Besuchern aus Wuppertal und Umgebung ein
                historisches Industrieanwesen mit beeindruckender
                Ziegelsteinfassade für Sport, Freizeit, unterschiedlichsten
                Veranstaltungen im Bergischen Land zur Verfügung.
              </p>
            </div>
          </section>

          <div className="flex flex-col gap-6 md:flex-row md:flex-wrap">
            <Image
              alt="Alte Papierfabrik aus der Vogelperspektive"
              height={215}
              src="/images/historie/1.png"
              width={358}
            />
            <Image
              alt="Alte Papierfabrik aus der Vogelperspektive"
              height={215}
              src="/images/historie/2.png"
              width={358}
            />
            <Image
              alt="Alte Papierfabrik aus der Vogelperspektive"
              height={215}
              src="/images/historie/3.png"
              width={358}
            />
          </div>
        </ScaffoldSectionContent>
      </ScaffoldSectionContainer>
    </ScaffoldSection>
  );
}
